import { ListerBranding } from '@smg-real-estate/hg-search-libs';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useListerBrandingStore = defineStore('listerBranding', () => {
  const listerBranding = ref<ListerBranding | undefined>(undefined);

  function setListerBranding(branding: ListerBranding | undefined) {
    listerBranding.value = branding;
  }

  return {
    // state
    listerBranding,

    // getters

    // actions
    setListerBranding,
  };
});
